import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import { instance } from "Actions/AxiosInstance";
import { GetMasterData } from "Actions/MasterCodeAction";
import crossIcon from "Assets/newicons/action/close-x/outline/close-x-outline-16px.svg";
import downArrow from "Assets/newicons/arrow/chevron/down/outline/chevron-down-outline-16px.svg";
import previewIcon from "Assets/newicons/user-interface/eye-show/outline/eye-show-outline-16px.svg";
import downArrowBlue from "Assets/Svg/down-arrow-blue.svg";
import pointingHandIcon from "Assets/Svg/hand-pointing-right.svg";
import selfImg from "Assets/Svg/self.svg";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import IconWithBackground from "Component/Icons/iconWithBackground";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { ChangeLanguage } from "../../../../../../Actions/LanguageAction";
import { checkboxinputconverter } from "../../../../../../Component/DynamicForm/Fields/CheckBox";
import { textareainputconverter } from "../../../../../../Component/DynamicForm/Fields/Textarea";
import { ErrorMessages } from "../../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
    fontWeight: "normal",
  },
  typography: {},
});

const ratingscales = [
  { displayvalue: 1, displayname: "3 point rating scale" },
  { displayvalue: 2, displayname: "4 point rating scale" },
  { displayvalue: 3, displayname: "5 point rating scale" },
  { displayvalue: 4, displayname: "7 point rating scale" },
  { displayvalue: 5, displayname: "10 point rating scale" },
];

const inputtypes = [
  { displayvalue: 2, displayname: "Multiple choice" },
  { displayvalue: 1, displayname: "Text input" },
];

const texttypes = [
  { displayvalue: 1, displayname: "Short" },
  { displayvalue: 2, displayname: "Paragraph" },
];

const ratingtypes = [
  { displayvalue: 1, displayname: "Number rating" },
  { displayvalue: 2, displayname: "Star rating" },
  { displayvalue: 3, displayname: "Emoji rating" },
];

class SectionB extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shownote: false,
      createmenu: false,
      create_anchorEl: null,
      responsetypemenu: false,
      responsetype_anchorEl: null,
      ratingtypes: [
        { displayvalue: 1, displayname: "Number rating" },
        { displayvalue: 2, displayname: "Star rating" },
        { displayvalue: 3, displayname: "Emoji rating" },
      ],
      advanceSettings: false,
      step: 2,
      response: this.props.allratings.find((a) => a.isdefault)
        ? this.props.allratings.find((a) => a.isdefault).ratingscaletypeid == 1
          ? "3 point rating scale"
          : this.props.allratings.find((a) => a.isdefault).ratingscaletypeid ==
            2
          ? "4 point rating scale"
          : this.props.allratings.find((a) => a.isdefault).ratingscaletypeid ==
            3
          ? "5 point rating scale"
          : this.props.allratings.find((a) => a.isdefault).ratingscaletypeid ==
            4
          ? "7 point rating scale"
          : this.props.allratings.find((a) => a.isdefault).ratingscaletypeid ==
            5
          ? "10 point rating scale"
          : "select type"
        : "",
      selectedData: props.selectedData || null,
      WeightageType: [],
      ParticipantType: [],
      competencies: [],
      showscale: false,
      ratingdetails: [],
      participents: [],
      issection: true,
      isfocus: false,
      isquestion: false,
      selectedSection: null,
      selectedFocus: null,
      selectedQuestion: null,
      selectedsectionindex: null,
      selectedquestionindex: null,
      selectedfocusindex: null,
    };
    this.isBackButtonClicked = false;
    this.createTabsNew = this.createTabsNew.bind(this);
    this.handleSelectTab = this.handleSelectTab.bind(this);
    this.handleSectionChange = this.handleSectionChange.bind(this);
    this.addfocusarea = this.addfocusarea.bind(this);
    this.handleFocusChange = this.handleFocusChange.bind(this);
    this.deleteFocus = this.deleteFocus.bind(this);
    this.addQuestion = this.addQuestion.bind(this);
    this.handlequestionChange = this.handlequestionChange.bind(this);
    this.addNewOption = this.addNewOption.bind(this);
    this.cancelOption = this.cancelOption.bind(this);
    this.deleteQuestion = this.deleteQuestion.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
    this.getRatingDetails = this.getRatingDetails.bind(this);
    this.onReset = this.onReset.bind(this);
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.getresponetypeopen = this.getresponetypeopen.bind(this);
  }

  async componentDidMount() {
    const { selectedData } = this.state;
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", this.onBeforeUpload);
    const WeightageType = await GetMasterData("WeightageType");
    this.getCompatency();
    this.getParticipents();
    this.props.onRef({
      onNext: () => this.onSubmit(false),
      // onSkip: () => this.onSubmit(true),
      // skipButtonLabel: "Skip Section B",
      // onSaveDraft:
      //   this.props.selectedData && this.props.selectedData.isdraft
      //     ? this.onSaveDraft
      //     : null,
      onSaveDraft: this.onSaveDraft,
    });
    // const obj = {
    //   focusareaid: null,
    //   focusareaname: selectedData.section[1].focusarea
    //     ? `Aptitude Focus area ${
    //     selectedData.section[1].focusarea.length + 1
    //     }`
    //     : "Aptitude Focus area 1",
    //   competencyid: null,
    //   reviewquestion: [],
    // };
    // const area = [];
    // area.push(obj);
    // selectedData.section[1].focusarea = area;
    this.setState({
      selectedData,
      selectedFocus: selectedData.section[1].focusarea[0],
      selectedQuestion: null,
      selectedquestionindex: null,
      selectedfocusindex: 0,
      issection: false,
      isfocus: true,
      isquestion: false,
    });
    this.addfocusarea();
    this.setState({
      WeightageType: WeightageType.data.result,
      // selectedSection: this.props.selectedData && this.props.selectedData.section && this.props.selectedData.section[1],
      selectedsectionindex: 1,
      issection: true,
      isfocus: true,
      isquestion: false,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.preventDefault();
    if (!this.isBackButtonClicked) {
      if (window.confirm("Are you sure you want to close the window/tab?")) {
        this.isBackButtonClicked = true;
        this.props.history.push("./config/perform/360/form");
      } else {
        window.history.pushState(null, null, window.location.pathname);
        this.isBackButtonClicked = false;
      }
    }
  }

  getCompatency() {
    instance
      .get("perform/competencylist")
      .then((result) => {
        this.setState({
          competencies: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getParticipents() {
    const { selectedData } = this.state;
    //   const ParticipantType = await GetMasterData("ParticipantType");
    //   this.setState({
    //   ParticipantType: ParticipantType.data.result,
    // });
    instance
      .get(
        `perform/reviewstructureparticipant/${
          selectedData && selectedData.reviewstructureid
        }`,
      )
      .then((result) => {
        this.setState({
          selectedSection: selectedData.section[1] && selectedData.section[1],
          ParticipantType: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleSelectTab(type, object, index, focus, focusindex) {
    const { selectedQuestion, selectedFocus, selectedSection } = this.state;
    if (selectedQuestion && !selectedQuestion.question) {
      this.props.enqueueSnackbar("please enter question name", {
        variant: "error",
      });
    } else if (selectedFocus && selectedFocus.focusareaname == " ") {
      this.props.enqueueSnackbar("please enter focus  name", {
        variant: "error",
      });
    } else if (selectedSection && !selectedSection.sectionname) {
      this.props.enqueueSnackbar("please enter section  name", {
        variant: "error",
      });
    } else if (type == "section") {
      this.setState({
        selectedType: type,
        selectedsectionindex: index,
        selectedSection: object,
        selectedfocusindex: null,
        selectedFocus: null,
        selectedquestionindex: null,
        selectedQuestion: null,
        shownote: false,
        showscale: false,
        issection: true,
        isfocus: false,
        isquestion: false,
      });
    } else if (type == "focus") {
      this.setState({
        selectedType: type,
        selectedfocusindex: index,
        selectedFocus: object,
        selectedquestionindex: null,
        selectedQuestion: null,
        shownote: false,
        showscale: false,
        issection: false,
        isfocus: true,
        isquestion: false,
      });
    } else {
      const responsedata =
        object.iscontributeinrating == false && object.questioninputtypeid == 1
          ? "Text input"
          : object.iscontributeinrating == false &&
            object.questioninputtypeid == 2
          ? "Multiple choice"
          : object.iscontributeinrating == true && object.ratingscaletypeid == 1
          ? "3 point rating scale"
          : object.iscontributeinrating == true && object.ratingscaletypeid == 2
          ? "4 point rating scale"
          : object.iscontributeinrating == true && object.ratingscaletypeid == 3
          ? "5 point rating scale"
          : object.iscontributeinrating == true && object.ratingscaletypeid == 4
          ? "7 point rating scale"
          : object.iscontributeinrating == true && object.ratingscaletypeid == 5
          ? "10 point rating scale"
          : "select type";
      this.setState(
        {
          selectedQuestion: null,
          isquestion: false,
        },
        () => {
          this.setState({
            selectedType: type,
            selectedquestionindex: index,
            selectedQuestion: object,
            selectedfocusindex: focusindex,
            selectedFocus: focus,
            shownote: false,
            showscale: false,
            issection: false,
            isfocus: false,
            isquestion: true,
            response: responsedata,
          });
        },
      );
    }
  }

  createTabsNew() {
    const {
      selectedData,
      selectedquestionindex,
      selectedsectionindex,
      selectedfocusindex,
    } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <ul className="padding0 margin-top-0 margin-bottom-0">
          {selectedData &&
            selectedData.section &&
            selectedData.section.map((section, sectionindex) => (
              <li className="review-form-section-tab">
                {sectionindex == 1 && (
                  <div
                    className={
                      sectionindex == selectedsectionindex
                        ? "active-section-tab"
                        : "inactive-section-tab"
                    }
                    onClick={() =>
                      this.handleSelectTab("section", section, sectionindex)
                    }
                  >
                    <Tooltip title={section.sectionname} placement="top">
                      <span>{section.sectionname}</span>
                    </Tooltip>
                  </div>
                )}
                {sectionindex == 1 && (
                  <ul
                    className="margin-top-0 margin-bottom-0"
                    style={{ padding: 0, paddingLeft: 10 }}
                  >
                    {section.focusarea &&
                      section.focusarea.map((focus, focusindex) => (
                        <li className="review-form-section-tab">
                          <div
                            className={
                              focusindex == selectedfocusindex
                                ? "active-section-tab"
                                : "inactive-section-tab"
                            }
                            onClick={() =>
                              this.handleSelectTab("focus", focus, focusindex)
                            }
                          >
                            <Tooltip
                              title={focus.focusareaname}
                              placement="top"
                            >
                              <span>{focus.focusareaname}</span>
                            </Tooltip>
                          </div>
                          <ul
                            className="margin-top-0 margin-bottom-0"
                            style={{ padding: 0, paddingLeft: 10 }}
                          >
                            {focus.reviewquestion &&
                              focus.reviewquestion.map(
                                (question, questionindex) => (
                                  <li className="review-form-section-tab">
                                    <div
                                      className={
                                        questionindex ==
                                          selectedquestionindex &&
                                        focusindex == selectedfocusindex
                                          ? "active-section-tab"
                                          : "inactive-section-tab"
                                      }
                                      onClick={() =>
                                        this.handleSelectTab(
                                          "question",
                                          question,
                                          questionindex,
                                          focus,
                                          focusindex,
                                        )
                                      }
                                    >
                                      <Tooltip
                                        title={question.question}
                                        classes={{
                                          tooltip: classes.customWidth,
                                        }}
                                        placement="top"
                                      >
                                        <span className="ellipsis width100 display-block">
                                          {question.question}
                                        </span>
                                      </Tooltip>
                                    </div>
                                  </li>
                                ),
                              )}
                          </ul>
                        </li>
                      ))}
                  </ul>
                )}
              </li>
            ))}
        </ul>
      </div>
    );
  }

  handleBlur(type, value, name) {
    const {
      selectedSection,
      selectedsectionindex,
      selectedData,
      selectedFocus,
      selectedfocusindex,
      selectedQuestion,
      selectedquestionindex,
    } = this.state;
    if (type == "section") {
      if (selectedSection && selectedsectionindex != null) {
        selectedSection[name] = value
          ? value
          : `Section ${selectedsectionindex == 0 ? "A" : "B"}`;
        selectedData.section[selectedsectionindex][name] = value
          ? value
          : `Section ${selectedsectionindex == 0 ? "A" : "B"}`;
        this.setState({
          selectedData,
          selectedSection,
        });
      }
    } else if (type == "focus") {
      if (selectedFocus && selectedfocusindex != null && selectedSection) {
        selectedFocus[name] = value
          ? value
          : `Focus area ${selectedfocusindex + 1}`;
        selectedData.section[selectedsectionindex].focusarea[
          selectedfocusindex
        ][name] = value ? value : `Focus area ${selectedfocusindex + 1}`;
        this.setState({
          selectedData,
          selectedFocus,
        });
      }
    } else if (type == "question") {
      if (
        selectedFocus &&
        selectedfocusindex != null &&
        selectedSection &&
        selectedQuestion
      ) {
        selectedQuestion[name] = value
          ? value
          : `Question ${selectedquestionindex + 1}`;
        selectedData.section[selectedsectionindex].focusarea[
          selectedfocusindex
        ].reviewquestion[selectedquestionindex][name] = value
          ? value
          : `Question ${selectedquestionindex + 1}`;
        this.setState({
          selectedData,
          selectedQuestion,
        });
      }
    }
  }

  handleSectionChange(value, key) {
    const {
      selectedSection,
      selectedsectionindex,
      selectedData,
      selectedQuestion,
    } = this.state;
    if (selectedSection && selectedsectionindex != null) {
      selectedSection[key] = value;
      selectedQuestion[key] = value;
      selectedData.section[selectedsectionindex][key] = value;
      this.setState({
        selectedData,
        selectedSection,
        selectedQuestion,
      });
    }
  }

  onReset() {
    this.props.enqueueSnackbar(
      "Are you sure you want to reset data of this section?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              const { selectedData } = this.state;
              // selectedData.section[1] = {
              //   reviewsectionid: null,
              //   sectionname: "Section B",
              //   weightagetypeid: null,
              //   focusarea: [],
              // };
              const obj = {
                focusareaid: null,
                focusareaname: "Focus area 1",
                competencyid: null,
                reviewquestion: [],
              };
              const area = [];
              area.push(obj);
              selectedData.section[1].focusarea = area;
              this.setState(
                {
                  selectedData,
                  selectedQuestion: null,
                  selectedFocus: selectedData.section[1].focusarea[0],
                  selectedSection: selectedData.section[1],
                  issection: true,
                  isfocus: true,
                  isquestion: false,
                },
                () => this.props.onResetClick(selectedData),
              );
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  }

  addfocusarea() {
    const { issection, isquestion } = this.state;
    if (issection || isquestion) {
      const { selectedSection, selectedsectionindex, selectedData } =
        this.state;
      if (selectedSection && selectedsectionindex != null) {
        const obj = {
          focusareaid: null,
          focusareaname: selectedData.section[selectedsectionindex].focusarea
            ? `Focus area ${
                selectedData.section[selectedsectionindex].focusarea.length + 1
              }`
            : "Focus area 1",
          competencyid: null,
          reviewquestion: [],
        };
        if (selectedData.section[selectedsectionindex].focusarea) {
          selectedData.section[selectedsectionindex].focusarea.push(obj);
          this.setState({
            selectedData,
            selectedFocus: obj,
            selectedfocusindex:
              selectedData.section[selectedsectionindex].focusarea.length - 1,
            issection: false,
            selectedQuestion: null,
            selectedquestionindex: null,
            isfocus: true,
            isquestion: false,
          });
        } else {
          const area = [];
          area.push(obj);
          selectedData.section[selectedsectionindex].focusarea = area;
          this.setState({
            selectedData,
            selectedFocus: obj,
            selectedQuestion: null,
            selectedquestionindex: null,
            selectedfocusindex: 0,
            issection: false,
            isfocus: true,
            isquestion: false,
          });
        }
      }
    }
  }

  handleFocusChange(value, key) {
    const {
      selectedSection,
      selectedData,
      selectedsectionindex,
      selectedFocus,
      selectedfocusindex,
    } = this.state;
    if (selectedFocus && selectedfocusindex != null && selectedSection) {
      selectedFocus[key] = value;
      selectedData.section[selectedsectionindex].focusarea[selectedfocusindex][
        key
      ] = value;
      this.setState({
        selectedData,
        selectedFocus,
      });
    }
  }

  deleteFocus() {
    const {
      selectedSection,
      selectedData,
      selectedsectionindex,
      selectedFocus,
      selectedfocusindex,
    } = this.state;
    if (selectedFocus && selectedfocusindex != null && selectedSection) {
      this.props.enqueueSnackbar(
        "Are you sure you want to remove this focus?",
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => {
                selectedData.section[selectedsectionindex].focusarea.splice(
                  selectedfocusindex,
                  1,
                );
                this.setState({
                  selectedData,
                  issection:
                    selectedData.section[selectedsectionindex].focusarea
                      .length == 0
                      ? true
                      : false,
                  isfocus:
                    selectedData.section[selectedsectionindex].focusarea
                      .length == 0
                      ? false
                      : true,
                  isquestion: false,
                  selectedFocus:
                    selectedData.section[selectedsectionindex].focusarea
                      .length == 0
                      ? null
                      : selectedData.section[selectedsectionindex].focusarea[
                          selectedData.section[selectedsectionindex].focusarea
                            .length - 1
                        ],
                  selectedfocusindex:
                    selectedData.section[selectedsectionindex].focusarea
                      .length == 0
                      ? null
                      : selectedData.section[selectedsectionindex].focusarea
                          .length - 1,
                });
                this.props.closeSnackbar();
              }}
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              No
            </Button>,
          ],
        },
      );
    }
  }

  addQuestion() {
    const { isfocus, isquestion, ParticipantType } = this.state;
    if (
      (isfocus && this.validateFocus()) ||
      (isquestion && this.validateQuestion())
    ) {
      const {
        selectedSection,
        selectedData,
        selectedsectionindex,
        selectedFocus,
        selectedfocusindex,
      } = this.state;
      if (!selectedFocus.competencyid) {
        this.props.enqueueSnackbar("Please select focus area", {
          variant: "error",
        });
      } else if (selectedSection && selectedFocus && selectedSection) {
        const obj = {
          reviewquestionid: null,
          // "question": "",
          question: selectedData.section[selectedsectionindex].focusarea[
            selectedfocusindex
          ].reviewquestion
            ? `Question ${
                selectedData.section[selectedsectionindex].focusarea[
                  selectedfocusindex
                ].reviewquestion.length + 1
              }`
            : "Question 1",
          iscontributeinrating: true,
          weightagetypeid: 4,
          ratingscaletypeid: this.props.allratings.find((a) => a.isdefault)
            ? this.props.allratings.find((a) => a.isdefault).ratingscaletypeid
            : null,
          ratingtypeid: 1,
          questioninputtypeid: 1,
          sizetypeid: null,
          questionevaluation: [],
          questioninputoption: [],
          description: null,
        };
        if (
          selectedData.section[selectedsectionindex].focusarea[
            selectedfocusindex
          ].reviewquestion
        ) {
          selectedData.section[selectedsectionindex].focusarea[
            selectedfocusindex
          ].reviewquestion.push(obj);
          this.setState({
            issection: false,
            isfocus: false,
            isquestion: true,
            selectedData,
            selectedQuestion: obj,
            selectedquestionindex:
              selectedData.section[selectedsectionindex].focusarea[
                selectedfocusindex
              ].reviewquestion.length - 1,
          });
        } else {
          const area = [];
          area.push(obj);
          selectedData.section[selectedsectionindex].focusarea[
            selectedfocusindex
          ].reviewquestion = area;
          this.setState({
            issection: false,
            isfocus: false,
            isquestion: true,
            selectedData,
            selectedQuestion: obj,
            selectedquestionindex: 0,
          });
        }
      }
    }
  }

  handlequestionChange(value, key, optionindex) {
    const ratingtypes1 = [
      { displayvalue: 1, displayname: "Number rating" },
      { displayvalue: 2, displayname: "Star rating" },
      { displayvalue: 3, displayname: "Emoji rating" },
    ];
    const ratingtypes2 = [{ displayvalue: 1, displayname: "Number rating" }];
    const {
      selectedquestionindex,
      selectedfocusindex,
      selectedData,
      selectedsectionindex,
      ParticipantType = [],
    } = this.state;
    let { selectedQuestion } = this.state;
    if (key == "iscontributeinrating") {
      const obj = {
        reviewquestionid: selectedQuestion.reviewquestionid,
        question: selectedQuestion.question,
        description: selectedQuestion.description,
        iscontributeinrating: value,
        weightagetypeid: !value ? 1 : null,
        ratingscaletypeid: null,
        ratingtypeid: value ? 1 : null,
        questioninputtypeid: value ? 1 : null,
        sizetypeid: null,
        questionevaluation: ParticipantType.map((x) => ({
          questionevaluationid: null,
          participanttypeid: x.displayvalue,
        })),
        questioninputoption: [],
      };
      selectedQuestion = obj;
      selectedData.section[selectedsectionindex].focusarea[
        selectedfocusindex
      ].reviewquestion[selectedquestionindex] = obj;
    } else if (key == "optionname") {
      selectedQuestion.questioninputoption[optionindex][key] = value;
      selectedData.section[selectedsectionindex].focusarea[
        selectedfocusindex
      ].reviewquestion[selectedquestionindex].questioninputoption[optionindex][
        key
      ] = value;
    } else if (key == "participanttypeid") {
      if (
        selectedQuestion.questionevaluation &&
        selectedQuestion.questionevaluation.length > 0
      ) {
        if (value == true) {
          selectedQuestion.questionevaluation.push({
            questionevaluationid: null,
            participanttypeid: optionindex,
          });
        } else if (value == false) {
          const index = selectedQuestion.questionevaluation.findIndex(
            (qe) => qe.participanttypeid == optionindex,
          );
          selectedQuestion.questionevaluation.splice(index, 1);
        }
      } else {
        const arr = [
          {
            questionevaluationid: null,
            participanttypeid: optionindex,
          },
        ];
        selectedQuestion.questionevaluation = arr;
      }
      selectedData.section[selectedsectionindex].focusarea[
        selectedfocusindex
      ].reviewquestion[selectedquestionindex] = selectedQuestion;
    } else if (key == "ratingscaletypeid" && value == 5) {
      const response = "10 point rating scale";
      selectedQuestion[key] = value;
      selectedQuestion.iscontributeinrating = true;
      selectedQuestion.sizetypeid = null;
      // selectedQuestion["questioninputtypeid"] = null;
      // selectedData.section[selectedsectionindex].focusarea[
      //   selectedfocusindex
      // ].reviewquestion[selectedquestionindex]["questioninputtypeid"] = null;
      selectedQuestion.ratingtypeid = 1;
      selectedData.section[selectedsectionindex].focusarea[
        selectedfocusindex
      ].reviewquestion[selectedquestionindex][key] = value;
      this.setState({
        response,
        ratingtypes: ratingtypes2,
      });
    } else if (key == "ratingscaletypeid" && value != 5) {
      const response =
        value == 1
          ? "3 point rating scale"
          : value == 2
          ? "4 point rating scale"
          : value == 3
          ? "5 point rating scale"
          : "7 point rating scale";
      selectedQuestion[key] = value;
      selectedQuestion.iscontributeinrating = true;
      selectedQuestion.sizetypeid = null;
      // selectedData.section[selectedsectionindex].focusarea[
      //   selectedfocusindex
      // ].reviewquestion[selectedquestionindex]["questioninputtypeid"] = null;
      selectedData.section[selectedsectionindex].focusarea[
        selectedfocusindex
      ].reviewquestion[selectedquestionindex][key] = value;
      this.setState({
        response,
        ratingtypes: value == 4 ? ratingtypes2 : ratingtypes1,
      });
    } else if (key == "questioninputtypeid") {
      const response = value == 2 ? "Multiple choice" : "Text input";
      selectedQuestion[key] = value;
      selectedQuestion.iscontributeinrating = false;
      if(value == 2){
        selectedQuestion.sizetypeid = null;
      }
      // selectedQuestion["ratingscaletypeid"] = null;
      // selectedData.section[selectedsectionindex].focusarea[
      //   selectedfocusindex
      // ].reviewquestion[selectedquestionindex]["ratingscaletypeid"] = null;
      selectedData.section[selectedsectionindex].focusarea[
        selectedfocusindex
      ].reviewquestion[selectedquestionindex][key] = value;
      this.setState({
        response,
        ratingtypes: value == 4 ? ratingtypes2 : ratingtypes1,
      });
    } else {
      selectedQuestion[key] = value;
      selectedData.section[selectedsectionindex].focusarea[
        selectedfocusindex
      ].reviewquestion[selectedquestionindex][key] = value;
    }
    this.setState({
      selectedQuestion,
      selectedData,
      showscale: false,
    });
  }

  addNewOption() {
    const {
      selectedQuestion,
      selectedquestionindex,
      selectedFocus,
      selectedfocusindex,
      selectedData,
      selectedsectionindex,
    } = this.state;
    if (selectedQuestion && selectedFocus) {
      if (selectedQuestion && selectedQuestion.questioninputoption.length < 1) {
        const arr = [];
        arr.push({
          questioninputoptionid: null,
          optionname: "",
        });
        selectedQuestion.questioninputoption = arr;
        selectedData.section[selectedsectionindex].focusarea[
          selectedfocusindex
        ].reviewquestion[selectedquestionindex] = selectedQuestion;
      } else if (
        selectedQuestion &&
        selectedQuestion.questioninputoption.length > 0
      ) {
        selectedQuestion.questioninputoption.push({
          questioninputoptionid: null,
          optionname: "",
        });
        selectedData.section[selectedsectionindex].focusarea[
          selectedfocusindex
        ].reviewquestion[selectedquestionindex] = selectedQuestion;
      }
    }
    this.setState({
      selectedData,
      selectedQuestion,
    });
  }

  cancelOption(optionindex) {
    const {
      selectedQuestion,
      selectedquestionindex,
      selectedFocus,
      selectedfocusindex,
      selectedData,
      selectedsectionindex,
    } = this.state;
    if (selectedQuestion && selectedFocus) {
      selectedQuestion.questioninputoption.splice(optionindex, 1);
      selectedData.section[selectedsectionindex].focusarea[
        selectedfocusindex
      ].reviewquestion[selectedquestionindex] = selectedQuestion;
      this.setState({
        selectedData,
        selectedQuestion,
      });
    }
  }

  deleteQuestion() {
    const {
      selectedData,
      selectedsectionindex,
      selectedFocus,
      selectedfocusindex,
      selectedQuestion,
      selectedquestionindex,
    } = this.state;
    if (selectedQuestion && selectedquestionindex != null && selectedFocus) {
      this.props.enqueueSnackbar(
        "Are you sure you want to remove this question?",
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => {
                selectedData.section[selectedsectionindex].focusarea[
                  selectedfocusindex
                ].reviewquestion.splice(selectedquestionindex, 1);
                this.setState({
                  selectedData,
                  issection: false,
                  isfocus:
                    selectedData.section[selectedsectionindex].focusarea[
                      selectedfocusindex
                    ].reviewquestion.length == 0
                      ? true
                      : false,
                  isquestion:
                    selectedData.section[selectedsectionindex].focusarea[
                      selectedfocusindex
                    ].reviewquestion.length == 0
                      ? false
                      : true,
                  selectedQuestion:
                    selectedData.section[selectedsectionindex].focusarea[
                      selectedfocusindex
                    ].reviewquestion.length == 0
                      ? null
                      : selectedData.section[selectedsectionindex].focusarea[
                          selectedfocusindex
                        ].reviewquestion[
                          selectedData.section[selectedsectionindex].focusarea[
                            selectedfocusindex
                          ].reviewquestion.length - 1
                        ],
                  selectedquestionindex:
                    selectedData.section[selectedsectionindex].focusarea[
                      selectedfocusindex
                    ].reviewquestion.length == 0
                      ? null
                      : selectedData.section[selectedsectionindex].focusarea[
                          selectedfocusindex
                        ].reviewquestion.length - 1,
                });
                this.props.closeSnackbar();
              }}
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              No
            </Button>,
          ],
        },
      );
    }
  }

  getresponetypeopen(event) {
    this.setState({
      responsetypemenu: !this.state.responsetypemenu,
      responsetype_anchorEl: event.currentTarget,
    });
  }

  getRatingDetails(event) {
    const { selectedQuestion } = this.state;
    if (selectedQuestion && selectedQuestion.ratingscaletypeid) {
      this.setState(
        {
          showscale: !this.state.showscale,
          createmenu: !this.state.createmenu,
          create_anchorEl: event.currentTarget,
        },
        () => {
          instance
            .get(`perform/getratingscale/${selectedQuestion.ratingscaletypeid}`)
            .then((result) => {
              const ratingdetails = [];
              Object.keys(result.data.result[0]).forEach((key) => {
                if (
                  key == "scaleone" ||
                  key == "scaletwo" ||
                  key == "scalethree"
                ) {
                  ratingdetails.push({
                    name:
                      key == "scaleone"
                        ? "1 point"
                        : key == "scaletwo"
                        ? "2 point"
                        : "3 point",
                    detail: result.data.result[0][key],
                  });
                } else if (
                  selectedQuestion.ratingscaletypeid != 1 &&
                  key == "scalefour"
                ) {
                  ratingdetails.push({
                    name: "4 point",
                    detail: result.data.result[0][key],
                  });
                } else if (
                  selectedQuestion.ratingscaletypeid != 1 &&
                  selectedQuestion.ratingscaletypeid != 2 &&
                  key == "scalefive"
                ) {
                  ratingdetails.push({
                    name: "5 point",
                    detail: result.data.result[0][key],
                  });
                } else if (
                  selectedQuestion.ratingscaletypeid != 1 &&
                  selectedQuestion.ratingscaletypeid != 2 &&
                  selectedQuestion.ratingscaletypeid != 3 &&
                  (key == "scalesix" || key == "scaleseven")
                ) {
                  ratingdetails.push({
                    name: key == "scalesix" ? "6 point" : "7 point",
                    detail: result.data.result[0][key],
                  });
                } else if (
                  selectedQuestion.ratingscaletypeid == 5 &&
                  (key == "scaleeight" ||
                    key == "scalenine" ||
                    key == "scaleten")
                ) {
                  ratingdetails.push({
                    name:
                      key == "scaleeight"
                        ? "8 point"
                        : key == "scalenine"
                        ? "9 point"
                        : "10 point",
                    detail: result.data.result[0][key],
                  });
                }
              });
              console.log("ratingdetails: ", ratingdetails);
              this.setState({
                ratingdetails: ratingdetails.reverse(),
              });
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        },
      );
    } else {
      this.props.enqueueSnackbar("Please select rating scale", {
        variant: "error",
      });
    }
  }

  validateSection(isaddfocus = false) {
    const { selectedSection } = this.state;
    let valid = true;
    if (
      selectedSection &&
      (selectedSection.weightagetypeid || isaddfocus == true)
    ) {
      if (!selectedSection.sectionname) {
        this.props.enqueueSnackbar("Please enter section name", {
          variant: "error",
        });
        valid = false;
      } else if (!selectedSection.weightagetypeid) {
        this.props.enqueueSnackbar("Please select weightage", {
          variant: "error",
        });
        valid = false;
      }
    }
    return valid;
  }

  validateFocus() {
    const { selectedFocus } = this.state;
    let valid = true;
    if (selectedFocus) {
      if (selectedFocus.focusareaname == " ") {
        this.props.enqueueSnackbar("Please enter focus area name", {
          variant: "error",
        });
        valid = false;
      }
      // else if (!selectedFocus.competencyid) {
      //   this.props.enqueueSnackbar("Please select competency", { variant: "error" });
      //   valid = false;
      // }
    }
    return valid;
  }

  validateFocus1(focus) {
    let valid = true;
    if (focus) {
      if (focus.focusareaname == " ") {
        this.props.enqueueSnackbar("Please enter focus area name", {
          variant: "error",
        });
        valid = false;
      }
      //  else if (!selectedFocus.competencyid) {
      //   this.props.enqueueSnackbar("Please select competency", { variant: "error" });
      //   valid = false;
      // }
    }
    return valid;
  }

  validateQuestion() {
    const { selectedQuestion } = this.state;
    let valid = true;
    if (selectedQuestion) {
      if (!selectedQuestion.question) {
        this.props.enqueueSnackbar("Please enter question name", {
          variant: "error",
        });
        valid = false;
      } else if (
        selectedQuestion.question &&
        selectedQuestion.question.length < 20
      ) {
        this.props.enqueueSnackbar(
          "Question should not be less than 20 characters",
          { variant: "error" },
        );
        valid = false;
      } else if (!selectedQuestion.iscontributeinrating) {
        if (!selectedQuestion.weightagetypeid) {
          this.props.enqueueSnackbar("Please select weightage", {
            variant: "error",
          });
          valid = false;
        } else if (!selectedQuestion.questioninputtypeid) {
          this.props.enqueueSnackbar("Please select question type", {
            variant: "error",
          });
          valid = false;
        } else if (
          selectedQuestion.questioninputtypeid == 2 &&
          selectedQuestion.questioninputoption.length < 2
        ) {
          this.props.enqueueSnackbar("Please add atleast 2 options", {
            variant: "error",
          });
          valid = false;
        } else if (
          selectedQuestion.questioninputtypeid == 2 &&
          selectedQuestion.questioninputoption &&
          selectedQuestion.questioninputoption.find((x) => !x.optionname)
        ) {
          this.props.enqueueSnackbar("Please enter optionnames", {
            variant: "error",
          });
          valid = false;
        } else if (
          selectedQuestion.questioninputtypeid == 1 &&
          !selectedQuestion.sizetypeid
        ) {
          this.props.enqueueSnackbar("Please select text input type", {
            variant: "error",
          });
          valid = false;
        } else if (
          !selectedQuestion.questionevaluation ||
          (selectedQuestion.questionevaluation &&
            selectedQuestion.questionevaluation.length == 0)
        ) {
          this.props.enqueueSnackbar("Please select particepents", {
            variant: "error",
          });
          valid = false;
        }
      } else if (selectedQuestion.iscontributeinrating) {
        if (!selectedQuestion.weightagetypeid) {
          this.props.enqueueSnackbar("Please select weightage", {
            variant: "error",
          });
          valid = false;
        } else if (!selectedQuestion.ratingscaletypeid) {
          this.props.enqueueSnackbar("Please select rating scale", {
            variant: "error",
          });
          valid = false;
        } else if (!selectedQuestion.ratingtypeid) {
          this.props.enqueueSnackbar("Please select rating type", {
            variant: "error",
          });
          valid = false;
        } else if (
          !selectedQuestion.questionevaluation ||
          (selectedQuestion.questionevaluation &&
            selectedQuestion.questionevaluation.length == 0)
        ) {
          this.props.enqueueSnackbar("Please select particepents", {
            variant: "error",
          });
          valid = false;
        }
      }
    }
    return valid;
  }

  validateQuestion1(selectedQuestion) {
    let valid = true;
    if (selectedQuestion) {
      if (!selectedQuestion.question) {
        this.props.enqueueSnackbar("Please enter question name", {
          variant: "error",
        });
        valid = false;
      } else if (
        selectedQuestion.question &&
        selectedQuestion.question.length < 20
      ) {
        this.props.enqueueSnackbar(
          "Question should not be less than 20 characters",
          { variant: "error" },
        );
        valid = false;
      } else if (!selectedQuestion.iscontributeinrating) {
        if (!selectedQuestion.weightagetypeid) {
          this.props.enqueueSnackbar("Please select weightage", {
            variant: "error",
          });
          valid = false;
        } else if (!selectedQuestion.questioninputtypeid) {
          this.props.enqueueSnackbar("Please select question type", {
            variant: "error",
          });
          valid = false;
        } else if (
          selectedQuestion.questioninputtypeid == 2 &&
          selectedQuestion.questioninputoption.length < 2
        ) {
          this.props.enqueueSnackbar("Please add atleast 2 options", {
            variant: "error",
          });
          valid = false;
        } else if (
          selectedQuestion.questioninputtypeid == 2 &&
          selectedQuestion.questioninputoption &&
          selectedQuestion.questioninputoption.find((x) => !x.optionname)
        ) {
          this.props.enqueueSnackbar("Please enter optionnames", {
            variant: "error",
          });
          valid = false;
        } else if (
          selectedQuestion.questioninputtypeid == 1 &&
          !selectedQuestion.sizetypeid
        ) {
          this.props.enqueueSnackbar("Please select text input type", {
            variant: "error",
          });
          valid = false;
        } else if (
          !selectedQuestion.questionevaluation ||
          (selectedQuestion.questionevaluation &&
            selectedQuestion.questionevaluation.length == 0)
        ) {
          this.props.enqueueSnackbar("Please select particepents", {
            variant: "error",
          });
          valid = false;
        }
      } else if (selectedQuestion.iscontributeinrating) {
        if (!selectedQuestion.weightagetypeid) {
          this.props.enqueueSnackbar("Please select weightage", {
            variant: "error",
          });
          valid = false;
        } else if (!selectedQuestion.ratingscaletypeid) {
          this.props.enqueueSnackbar("Please select rating scale", {
            variant: "error",
          });
          valid = false;
        } else if (!selectedQuestion.ratingtypeid) {
          this.props.enqueueSnackbar("Please select rating type", {
            variant: "error",
          });
          valid = false;
        } else if (
          !selectedQuestion.questionevaluation ||
          (selectedQuestion.questionevaluation &&
            selectedQuestion.questionevaluation.length == 0)
        ) {
          this.props.enqueueSnackbar("Please select particepents", {
            variant: "error",
          });
          valid = false;
        }
      }
    }
    return valid;
  }

  onSaveDraft() {
    const { issection, isfocus, isquestion, selectedData } = this.state;
    if (
      (issection && this.validateSection()) ||
      (isfocus && this.validateFocus()) ||
      (isquestion && this.validateQuestion())
    ) {
      selectedData.isdraft = true;
      if (
        selectedData.formfor &&
        !selectedData.formfor.fortypeid &&
        !selectedData.formfor.forids
      ) {
        selectedData.formfor = null;
      }
      if (selectedData.formfor && selectedData.formfor.forids) {
        selectedData.formfor.forids = Array.isArray(selectedData.formfor.forids)
          ? selectedData.formfor.forids.join(",")
          : selectedData.formfor.forids;
      }
      if (selectedData.section[0]) {
        selectedData.section[0].focusarea =
          selectedData.section[0].focusarea.length < 1
            ? null
            : selectedData.section[0].focusarea;
        if (
          selectedData.section[0].focusarea &&
          selectedData.section[0].focusarea.length > 0
        ) {
          selectedData.section[0].focusarea =
            selectedData.section[0].focusarea.map((area) => ({
              ...area,
              reviewquestion:
                area.reviewquestion && area.reviewquestion.length > 0
                  ? area.reviewquestion.map((q) => ({
                      ...q,
                      questioninputoption:
                        !q.questioninputoption ||
                        q.questioninputoption.length < 1
                          ? null
                          : q.questioninputoption,
                    }))
                  : null,
            }));
        }
      }
      if (selectedData.section[1] && selectedData.section[1].weightagetypeid) {
        selectedData.section[1].focusarea =
          selectedData.section[1].focusarea.length < 1
            ? null
            : selectedData.section[1].focusarea;
        if (
          selectedData.section[1].focusarea &&
          selectedData.section[1].focusarea.length > 0
        ) {
          selectedData.section[1].focusarea =
            selectedData.section[1].focusarea.map((area) => ({
              ...area,
              reviewquestion:
                area.reviewquestion && area.reviewquestion.length > 0
                  ? area.reviewquestion.map((q) => ({
                      ...q,
                      questioninputoption:
                        !q.questioninputoption ||
                        q.questioninputoption.length < 1
                          ? null
                          : q.questioninputoption,
                    }))
                  : null,
            }));
        }
      } else {
        selectedData.section = [selectedData.section[0]];
      }
      selectedData.section = selectedData.section.filter(
        (sec) => sec.weightagetypeid,
      );
      instance
        .post("perform/configreviewform", selectedData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.onCancel(true);
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  onSubmit(isSkip) {
    const { selectedData } = this.state;
    if (isSkip) {
      this.props.enqueueSnackbar(
        "Are you sure you want to skip this section?",
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => {
                this.props.closeSnackbar();
                selectedData.section[1] = {
                  reviewsectionid: null,
                  sectionname: "Section B",
                  weightagetypeid: null,
                  focusarea: [],
                };
                this.props.onSkipClick(selectedData);
              }}
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              No
            </Button>,
          ],
        },
      );
    } else if (!isSkip) {
      if (
        selectedData.section[1] &&
        selectedData.section[1].weightagetypeid &&
        selectedData.section[1] &&
        (!selectedData.section[1].focusarea ||
          selectedData.section[1].focusarea.length < 1)
      ) {
        this.props.enqueueSnackbar("Please add at least one focus area", {
          variant: "error",
        });
      } else if (
        selectedData.section[1] &&
        selectedData.section[1].weightagetypeid &&
        selectedData.section[1].focusarea &&
        selectedData.section[1].focusarea.find(
          (x) => !x.reviewquestion || x.reviewquestion.length == 0,
        )
      ) {
        this.props.enqueueSnackbar(
          "Please add at least one question in every focus area",
          { variant: "error" },
        );
      } else if (this.validateSection()) {
        let valid = true;
        selectedData.section[1].focusarea.forEach((focus) => {
          if (valid) {
            if (this.validateFocus1(focus)) {
              focus.reviewquestion.forEach((q) => {
                if (valid) {
                  if (this.validateQuestion1(q)) {
                    valid = true;
                  } else {
                    valid = false;
                  }
                }
              });
            } else {
              valid = false;
            }
          }
        });
        if (valid) this.props.onNextClick(selectedData);
        return;
      }
    }
  }

  render() {
    const {
      selectedSection,
      WeightageType,
      selectedFocus,
      selectedQuestion,
      selectedquestionindex,
      selectedfocusindex,

      competencies,
      ratingdetails,
      ParticipantType,
      issection,
      isfocus,
      isquestion,
      selectedData,
    } = this.state;

    const selectedcompetnecy =
      selectedFocus && selectedFocus.competencyid
        ? competencies.find(
            (comp) => comp.displayvalue == selectedFocus.competencyid,
          )
        : null;
    let allfocuses = [];
    allfocuses = selectedData.section[0].focusarea
      ? [...selectedData.section[0].focusarea]
      : [];
    allfocuses =
      selectedSection && selectedSection.focusarea && selectedSection.focusarea
        ? [
            ...allfocuses,
            ...(selectedSection &&
              selectedSection.focusarea &&
              selectedSection.focusarea),
          ]
        : [...allfocuses];
    console.log("allfocuses: ", allfocuses);
    const filtercompetencies = competencies.filter(
      (x) =>
        allfocuses &&
        allfocuses
          .filter((x1) => x1.competencyid)
          .findIndex((focus) => focus.competencyid == x.displayvalue) == -1,
    );

    return (
      <Grid container>
        <Grid
          item
          xs={12}
          md={3}
          sm={12}
          className="rounded-rectangle-div"
          style={{ padding: 16 }}
        >
          {/* {this.createTabs()} */}
          {this.createTabsNew()}
          {/* <button className="add-tab-button" onClick={this.handleAddTab}>
            <i className="text-primary fas fa-plus-square" /> Add Tab
          </button> */}
        </Grid>
        <Grid
          item
          md={9}
          sm={12}
          className="padding-left-24"
          style={{ height: 500, overflowY: "auto" }}
        >
          <div className="tab-content">
            {/* {issection && selectedSection && (
              <div>
                <p className="normal-dark-secondary t-bold margin-bottom-16">
                  Section B
                </p>
                <div className="width50">
                  <DynamicForm
                    fields={textinputconverter({
                      value: selectedSection.sectionname,
                      placeholder: "Enter section name",
                      label: "Give this section a name",
                    })}
                    onBlur={(value) => {
                      this.handleBlur(
                        "section",
                        value.target.value,
                        "sectionname",
                      );
                    }}
                    onChange={(value) => {
                      this.handleSectionChange(value, "sectionname");
                    }}
                  />
                </div>
                <div>
                  <span style={{ width: 200, float: "left" }}>
                    <DynamicForm
                      fields={selectinputconverter({
                        value: selectedSection.weightagetypeid,
                        placeholder: "Select weightage",
                        label: "Set weightage",
                        options: WeightageType,
                      })}
                      onChange={(value) => {
                        this.handleSectionChange(value, "weightagetypeid");
                      }}
                    />
                  </span>
                  <span
                    style={{
                      float: "left",
                      position: "relative",
                      width: "50%",
                    }}
                  >
                    <span
                      className="cursour-pointer"
                      style={{ position: "absolute", top: 26, left: 10 }}
                      onClick={() => this.setState({ shownote: true })}
                    >
                      💡
                    </span>

                    {shownote && (
                      <div style={{ position: "absolute", top: 18, left: 40 }}>
                        <CallOutNew
                          classnames="bg-light-blue width100"
                          header="Weightage lets you define the importance of a section or question with respect to another section or question."
                          emoji=""
                          textcolor="#1e8ced"
                        />
                      </div>
                    )}
                  </span>
                  <div className="clear-float"></div>
                </div>

                <Button
                  className="add-tab-button btn btn-primary-md-blue margin-top-32"
                  onClick={this.onReset}
                  variant="contained"
                >
                  Reset
                </Button>
                <Button
                  className="add-tab-button btn btn-primary-md-blue margin-top-32 margin-left-16"
                  onClick={this.addfocusarea}
                  variant="contained"
                >
                  Add focus area
                </Button>
              </div>
            )} */}
            {isfocus && selectedFocus && (
              <div>
                <div>
                  <p className="normal-dark-secondary t-bold margin-bottom-16">
                    {`Focus area ${parseInt(selectedfocusindex) + 1}`}
                  </p>
                  {/* <div className="width50">
                    <DynamicForm
                      fields={textinputconverter({
                        value: selectedFocus.focusareaname,
                        placeholder: "Enter focus area name",
                        label: "Give this focus area a name",
                      })}
                      onBlur={(value) => {
                        this.handleBlur(
                          "focus",
                          value.target.value,
                          "focusareaname",
                        );
                      }}
                      onChange={(value) => {
                        this.handleFocusChange(value, "focusareaname");
                      }}
                    />
                  </div> */}
                  <div style={{ width: 208 }}>
                    <p className="input-label">Select focus area</p>
                    <Select
                      onChange={(value) => {
                        this.handleFocusChange(
                          value ? value.displayvalue : null,
                          "competencyid",
                        );
                      }}
                      value={selectedcompetnecy}
                      options={filtercompetencies}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                    />
                  </div>
                  <div className="margin-top-32">
                    {selectedData.section[1].focusarea.length > 1 && (
                      <Button
                        className="btn btn-secondary-md-red floatleft"
                        variant="contained"
                        onClick={this.deleteFocus}
                      >
                        Delete
                      </Button>
                    )}

                    <Button
                      className="btn btn-secondary-md-blue margin-left-8"
                      onClick={this.onReset}
                      variant="contained"
                    >
                      Reset
                    </Button>
                    <Button
                      className="btn btn-primary-md-blue floatright"
                      variant="contained"
                      onClick={this.addQuestion}
                    >
                      Add question
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {isquestion && selectedQuestion && (
              <div>
                <p className="normal-dark-secondary t-bold margin-bottom-16">
                  {`Question ${parseInt(selectedquestionindex) + 1}`}
                </p>
                <div
                  className="display-flex"
                  style={{ alignItems: "flex-start" }}
                >
                  <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                  <div className="width60">
                    <p className="normal-dark margin-bottom-8 display-flex">
                      State your question
                    </p>

                    <DynamicForm
                      fields={textinputconverter({
                        value: selectedQuestion.question,
                        placeholder: "Title",
                        label: "Title",
                      })}
                      onBlur={(value) => {
                        this.handleBlur(
                          "question",
                          value.target.value,
                          "question",
                        );
                      }}
                      onChange={(value) => {
                        this.handlequestionChange(value, "question");
                      }}
                    />

                    <DynamicForm
                      fields={textareainputconverter({
                        value: selectedQuestion.description,
                        placeholder: "",
                        label: "Description (Optional)",
                      })}
                      onChange={(value) => {
                        this.handlequestionChange(value, "description");
                      }}
                    />
                  </div>
                </div>

                <div
                  className="display-flex"
                  style={{ alignItems: "flex-start" }}
                >
                  <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                  <div className="width60">
                    <p className="normal-dark margin-bottom-8 display-flex">
                      Configure response
                    </p>
                    <p className="inpput-label">Select response type</p>
                    <div
                      className="rounded-rectangle-div padding8 display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                      onClick={this.getresponetypeopen}
                    >
                      <p className="small-dark-secondary">
                        {this.state.response}
                      </p>
                      <img src={downArrow}></img>
                    </div>

                    <Popover
                      open={this.state.responsetypemenu}
                      anchorEl={this.state.responsetype_anchorEl}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      onClose={() => this.setState({ responsetypemenu: false })}
                      className="margin-top-8"
                    >
                      <Paper
                        style={{ width: 220, padding: "0px 8px 0px" }}
                        onClick={() =>
                          this.setState({
                            responsetypemenu: !this.state.responsetypemenu,
                          })
                        }
                      >
                        <List>
                          <ListSubheader
                            style={{ paddingLeft: 8, lineHeight: "32px" }}
                          >
                            Weighted
                          </ListSubheader>
                          <ListItem
                            style={{ paddingTop: 4, paddingBottom: 4 }}
                            className="cursor-pointer"
                            onClick={() =>
                              this.setState({ responsetypemenu: false }, () => {
                                this.handlequestionChange(
                                  1,
                                  "ratingscaletypeid",
                                );
                              })
                            }
                          >
                            <p className="small-dark-secondary">
                              3 point rating
                            </p>
                          </ListItem>
                          <ListItem
                            style={{ paddingTop: 4, paddingBottom: 4 }}
                            className="cursor-pointer"
                            onClick={() =>
                              this.setState({ responsetypemenu: false }, () => {
                                this.handlequestionChange(
                                  2,
                                  "ratingscaletypeid",
                                );
                              })
                            }
                          >
                            <p className="small-dark-secondary">
                              4 point rating
                            </p>
                          </ListItem>
                          <ListItem
                            style={{ paddingTop: 4, paddingBottom: 4 }}
                            className="cursor-pointer"
                            onClick={() =>
                              this.setState({ responsetypemenu: false }, () => {
                                this.handlequestionChange(
                                  3,
                                  "ratingscaletypeid",
                                );
                              })
                            }
                          >
                            <p className="small-dark-secondary">
                              5 point rating
                            </p>
                          </ListItem>
                          <ListItem
                            style={{ paddingTop: 4, paddingBottom: 4 }}
                            className="cursor-pointer"
                            onClick={() =>
                              this.setState({ responsetypemenu: false }, () => {
                                this.handlequestionChange(
                                  4,
                                  "ratingscaletypeid",
                                );
                              })
                            }
                          >
                            <p className="small-dark-secondary">
                              7 point rating
                            </p>
                          </ListItem>
                          <ListItem
                            style={{ paddingTop: 4, paddingBottom: 4 }}
                            className="cursor-pointer"
                            onClick={() =>
                              this.setState({ responsetypemenu: false }, () => {
                                this.handlequestionChange(
                                  5,
                                  "ratingscaletypeid",
                                );
                              })
                            }
                          >
                            <p className="small-dark-secondary">
                              10 point rating
                            </p>
                          </ListItem>
                          <ListSubheader
                            style={{ paddingLeft: 8, lineHeight: "32px" }}
                          >
                            Un-weighted
                          </ListSubheader>

                          <ListItem
                            style={{ paddingTop: 4, paddingBottom: 4 }}
                            className="cursor-pointer"
                            onClick={() =>
                              this.setState({ responsetypemenu: false }, () => {
                                this.handlequestionChange(
                                  2,
                                  "questioninputtypeid",
                                );
                              })
                            }
                          >
                            <p className="small-dark-secondary">
                              Multiple choice
                            </p>
                          </ListItem>
                          <ListItem
                            style={{ paddingTop: 4, paddingBottom: 4 }}
                            className="cursor-pointer"
                            onClick={() =>
                              this.setState({ responsetypemenu: false }, () => {
                                this.handlequestionChange(
                                  1,
                                  "questioninputtypeid",
                                );
                              })
                            }
                          >
                            <p className="small-dark-secondary">Text input</p>
                          </ListItem>
                        </List>
                      </Paper>
                    </Popover>
                    {selectedQuestion.iscontributeinrating == false &&
                      selectedQuestion.questioninputtypeid == 1 && (
                        <div>
                          <div style={{ width: 220 }}>
                            <DynamicForm
                              fields={selectinputconverter({
                                value: selectedQuestion.sizetypeid,
                                placeholder: "Select text type",
                                label: "",
                                options: texttypes,
                              })}
                              onChange={(value) => {
                                this.handlequestionChange(value, "sizetypeid");
                              }}
                            />
                          </div>
                        </div>
                      )}
                    {selectedQuestion.iscontributeinrating == false &&
                      selectedQuestion.questioninputtypeid == 2 && (
                        <div>
                          <p className="input-label margin-bottom-8">
                            Create multiple choice options
                          </p>
                          <div>
                            {selectedQuestion &&
                              selectedQuestion &&
                              selectedQuestion.questioninputoption &&
                              selectedQuestion.questioninputoption.map(
                                (option, optionindex) => (
                                  <div>
                                    <span
                                      style={{
                                        width: 220,
                                        marginRight: 16,
                                        float: "left",
                                      }}
                                    >
                                      <DynamicForm
                                        fields={textinputconverter({
                                          value: option.optionname,
                                          placeholder: "Enter option",
                                          label: "",
                                        })}
                                        onChange={(value) => {
                                          this.handlequestionChange(
                                            value,
                                            "optionname",
                                            optionindex,
                                          );
                                        }}
                                      />
                                    </span>
                                    <span
                                      className="cursor-pointer"
                                      style={{ float: "left", marginTop: 12 }}
                                      onClick={() =>
                                        this.cancelOption(optionindex)
                                      }
                                    >
                                      <img src={crossIcon}></img>
                                    </span>
                                    <div className="clear-float"></div>
                                  </div>
                                ),
                              )}
                            <p
                              className="normal-blue cursor-pointer t-bold"
                              onClick={this.addNewOption}
                            >
                              + Add option
                            </p>
                            {/* <CallOutNew
                            classnames="bg-light-blue width100"
                            header="Are you sure employees won't select the first option and move on?"
                            emoji=""
                            textcolor="#1E8CED"
                          /> */}
                            {/* {this.state.addoptions && (
                            <DynamicForm
                              fields={textinputconverter({
                                value: this.state.option1,
                                placeholder: "Enter option",
                                label: "",
                              })}
                              onChange={(value) => {
                                this.handleChange(value, "option1");
                              }}
                            />
                          )} */}
                          </div>
                        </div>
                      )}

                    <div
                      className="helping-hand-wrapper"
                      style={{
                        padding: 16,
                        width: "calc(100% - 34px)",
                        marginBottom: 32,
                      }}
                    >
                      <p className="helping-hand-text text-center margin-bottom-16">
                        Helping Hand 👋
                      </p>
                      <p className="small-dark-secondary">
                        Weighted responses contribute to the ‘Overall
                        Performance Score’ of the employee. Use un-weighted
                        responses to get opinionated feedback.
                      </p>
                    </div>
                    {selectedQuestion.iscontributeinrating && (
                      <div className="display-flex">
                        <div className="width80">
                          <DynamicForm
                            fields={selectinputconverter({
                              value: selectedQuestion.ratingtypeid,
                              placeholder: "Select rating",
                              label: "Select rating type",
                              options: this.state.ratingtypes,
                            })}
                            onChange={(value) => {
                              this.handlequestionChange(value, "ratingtypeid");
                            }}
                          />
                        </div>
                        <div
                          className="margin-left-16 margin-top-20 cursor-pointer"
                          onClick={this.getRatingDetails}
                        >
                          <IconWithBackground imgsrc={previewIcon} />
                        </div>

                        <Popover
                          open={this.state.createmenu}
                          anchorEl={this.state.create_anchorEl}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                          onClose={() => this.setState({ createmenu: false })}
                          className=""
                        >
                          <Paper style={{ width: 220, padding: 16 }}>
                            {ratingdetails &&
                              ratingdetails.map((det) => (
                                <div
                                  className="margin-bottom-8 display-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <p className="small-dark margin-right-8 width25">
                                    {det.name}
                                  </p>
                                  <p className="small-dark width75">
                                    {det.detail}
                                  </p>
                                </div>
                              ))}
                          </Paper>
                        </Popover>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className="display-flex"
                  style={{ alignItems: "flex-start" }}
                >
                  <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                  <div className="width100">
                    <p className="normal-dark margin-bottom-8 display-flex">
                      Select participants for this question
                    </p>
                    <div className="display-flex">
                      {ParticipantType &&
                        ParticipantType.map((option) => (
                          <div
                            style={{
                              width: "calc(25% - 16px)",
                              height: 160,
                              background: "#edf5fd",
                              padding: "8px 0px 0px 8px",
                              position: "relative",
                              marginRight: 16,
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                              }}
                            >
                              <DynamicForm
                                fields={checkboxinputconverter({
                                  value:
                                    selectedQuestion.questionevaluation.find(
                                      (obj) =>
                                        obj.participanttypeid ==
                                        option.displayvalue,
                                    )
                                      ? true
                                      : false,
                                  placeholder: "Enter option",
                                  label: option.displayname,
                                })}
                                onChange={(value) => {
                                  const object =
                                    selectedQuestion.questionevaluation.find(
                                      (obj) =>
                                        obj.participanttypeid ==
                                        option.displayvalue,
                                    );
                                  if (object && object.questionevaluationid) {
                                    this.props.closeSnackbar();
                                    this.props.enqueueSnackbar(
                                      "Are you sure you want to remove this participant from this question?",
                                      {
                                        variant: "warning",
                                        action: [
                                          <Button
                                            key="key"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                              this.handlequestionChange(
                                                value,
                                                "participanttypeid",
                                                option.displayvalue,
                                              );
                                              this.props.closeSnackbar();
                                            }}
                                          >
                                            Yes
                                          </Button>,
                                          <Button
                                            key="key"
                                            color="inherit"
                                            size="small"
                                            onClick={() =>
                                              this.props.closeSnackbar()
                                            }
                                          >
                                            No
                                          </Button>,
                                        ],
                                      },
                                    );
                                  } else {
                                    this.handlequestionChange(
                                      value,
                                      "participanttypeid",
                                      option.displayvalue,
                                    );
                                  }
                                }}
                              />
                            </div>
                            <img
                              style={{
                                position: "absolute",
                                bottom: 0,
                                right: 0,
                                width: "100%",
                              }}
                              src={selfImg}
                            ></img>
                          </div>
                        ))}
                    </div>
                    {/* <div className="margin-bottom-24 display-flex">
                      <div
                        style={{
                          width: 200,
                          height: 184,
                          background: "#edf5fd",
                          padding: "16px 0px 0px 16px",
                          position: "relative",
                          marginRight: 16,
                        }}
                      >
                        <div
                          style={{
                            width: "calc(100% - 32px)",
                            height: "100%",
                          }}
                        >
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value: participant[0].isSelected,
                              placeholder: "",
                              label: "Self",
                              // disabled: participant[0].isSelected == false ? true : false,
                            })}
                            onChange={(value) =>
                              this.handleChange1("isSelected", value, 1)
                            }
                          />
                        </div>
                        <img
                          style={{ position: "absolute", top: 0 }}
                          src={selfImg}
                        ></img>
                      </div>
                      <div
                        style={{
                          width: 200,
                          height: 184,
                          background: "#edf5fd",
                          padding: "16px 0px 0px 16px",
                          position: "relative",
                          marginRight: 16,
                        }}
                      >
                        <div
                          style={{
                            width: "calc(100% - 32px)",
                            height: "100%",
                          }}
                        >
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value:
                                participant[1] && participant[1].isSelected,
                              placeholder: "",
                              label: "Manager",
                              // disabled: participant[1].isSelected == false ? true : false,
                            })}
                            onChange={(value) =>
                              this.handleChange1("isSelected", value, 2)
                            }
                          />
                          <img
                            style={{ position: "absolute", top: 0 }}
                            src={managerImg}
                          ></img>
                        </div>
                      </div>
                      <div
                        style={{
                          width: 200,
                          height: 184,
                          background: "#edf5fd",
                          padding: "16px 0px 0px 16px",
                          position: "relative",
                          marginRight: 16,
                        }}
                      >
                        <div
                          style={{
                            width: "calc(100% - 32px)",
                            height: "100%",
                          }}
                        >
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value:
                                participant[2] && participant[2].isSelected,
                              placeholder: "",
                              label: "Junior employee",
                              // disabled: participant[2].isSelected == false ? true : false
                            })}
                            onChange={(value) =>
                              this.handleChange1("isSelected", value, 3)
                            }
                          />
                          <img
                            style={{ position: "absolute", top: 0 }}
                            src={directreportImg}
                          ></img>
                        </div>
                      </div>
                      <div
                        style={{
                          width: 200,
                          height: 184,
                          background: "#edf5fd",
                          padding: "16px 0px 0px 16px",
                          position: "relative",
                          marginRight: 16,
                        }}
                      >
                        <div
                          style={{
                            width: "calc(100% - 32px)",
                            height: "100%",
                          }}
                        >
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value:
                                participant[3] && participant[3].isSelected,
                              placeholder: "",
                              label: "Co-workers",
                            })}
                            onChange={(value) =>
                              this.handleChange1("isSelected", value, 4)
                            }
                          />
                          <img
                            style={{ position: "absolute", top: 0 }}
                            src={coworkerImg}
                          ></img>
                        </div>
                      </div>
                    </div>
                    */}
                  </div>
                </div>
                {selectedQuestion.iscontributeinrating && (
                  <>
                    <div
                      className="margin-bottom-24 margin-top-24 margin-left-32 cursor-pointer display-flex"
                      onClick={() =>
                        this.setState({
                          advanceSettings: !this.state.advanceSettings,
                        })
                      }
                    >
                      <p className="small-blue t-bold">Show advance settings</p>
                      <img src={downArrowBlue}></img>
                    </div>

                    {selectedQuestion.iscontributeinrating && (
                      <div style={{ width: 200 }}>
                        <DynamicForm
                          fields={selectinputconverter({
                            value: selectedQuestion.weightagetypeid,
                            placeholder: "Select weightage",
                            label: "Set weightage",
                            options: WeightageType,
                          })}
                          onChange={(value) => {
                            this.handlequestionChange(value, "weightagetypeid");
                          }}
                        />
                      </div>
                    )}
                  </>
                )}

                {/* <div className="margin-bottom-16">
                  <span className="floatleft margin-right-8">
                    <Switch
                      checked={
                        selectedQuestion.iscontributeinrating ? true : false
                      }
                      onChange={(e) =>
                        this.handlequestionChange(
                          e.target.value == "true" ? false : true,
                          "iscontributeinrating",
                        )
                      }
                      value={
                        selectedQuestion.iscontributeinrating ? true : false
                      }
                      // name={column}
                      color="primary"
                    />
                  </span>
                  <span className="floatleft margin-right-8">
                    <p className="small-dark-secondary padding-top-10 t-bold">
                      This question contributes to the total rating.
                    </p>
                  </span>
                  <div className="clear-float"></div>
                </div>

                {selectedQuestion.iscontributeinrating ? (
                  <div className="light-grey-bg width60">
                    <span style={{ width: 220, display: "block" }}>
                      <DynamicForm
                        fields={selectinputconverter({
                          value: selectedQuestion.weightagetypeid,
                          placeholder: "Select weightage",
                          label: "Set weightage",
                          options: WeightageType,
                        })}
                        onChange={(value) => {
                          this.handlequestionChange(value, "weightagetypeid");
                        }}
                      />
                    </span>
                    <div>
                      <div
                        style={{
                          width: 220,
                          float: "left",
                          marginRight: 16,
                        }}
                      >
                        <DynamicForm
                          fields={selectinputconverter({
                            value: selectedQuestion.ratingscaletypeid,
                            placeholder: "",
                            label: "Rating scale",
                            options: ratingscales,
                          })}
                          onChange={(value) => {
                            this.handlequestionChange(
                              value,
                              "ratingscaletypeid",
                            );
                          }}
                        />
                      </div>
                      <div
                        className="floatleft position-rel"
                        style={{ marginTop: 20, width: "38%" }}
                      >
                        <span
                          className={
                            selectedQuestion &&
                            selectedQuestion.ratingtypeid &&
                            selectedQuestion.ratingtypeid == 1
                              ? "rating-scale-types-selected"
                              : "rating-scale-types"
                          }
                          onClick={() =>
                            this.handlequestionChange(1, "ratingtypeid")
                          }
                        >
                          123
                        </span>
                        {selectedQuestion &&
                        selectedQuestion.ratingscaletypeid &&
                        (selectedQuestion.ratingscaletypeid == 4 ||
                          selectedQuestion.ratingscaletypeid == 5) ? (
                          ""
                        ) : (
                          <div>
                            {selectedQuestion &&
                              selectedQuestion.ratingscaletypeid && (
                                <span
                                  className={
                                    selectedQuestion &&
                                    selectedQuestion.ratingtypeid &&
                                    selectedQuestion.ratingtypeid == 2
                                      ? "rating-scale-types-selected"
                                      : "rating-scale-types"
                                  }
                                  onClick={() =>
                                    this.handlequestionChange(2, "ratingtypeid")
                                  }
                                >
                                  <img
                                    src={
                                      selectedQuestion &&
                                      selectedQuestion.ratingtypeid &&
                                      selectedQuestion.ratingtypeid == 2
                                        ? starIconBlue
                                        : starIcon
                                    }
                                    className="vertical-center"
                                  ></img>
                                </span>
                              )}
                            {selectedQuestion &&
                              selectedQuestion.ratingscaletypeid && (
                                <span
                                  className={
                                    selectedQuestion &&
                                    selectedQuestion.ratingtypeid &&
                                    selectedQuestion.ratingtypeid == 3
                                      ? "rating-scale-types-selected"
                                      : "rating-scale-types"
                                  }
                                  onClick={() =>
                                    this.handlequestionChange(3, "ratingtypeid")
                                  }
                                  style={{
                                    fontSize: 16,
                                    lineHeight: "26px",
                                  }}
                                >
                                  <span>👍</span>
                                </span>
                              )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      {showscale ? (
                        <div>
                          <span
                            className="extra-small-blue t-bold margin-bottom-16 display-block clear-left cursor-pointer"
                            onClick={() =>
                              this.setState({
                                showscale: false,
                                ratingdetails: [],
                              })
                            }
                          >
                            Hide rating scale
                          </span>
                          <div>
                            {ratingdetails &&
                              ratingdetails.map((det) => (
                                <div className="margin-bottom-8">
                                  <span className="small-green-dark floatleft margin-right-16 t-bold">
                                    {det.name}
                                  </span>
                                  <span className="small-dark-secondary floatleft">
                                    {det.detail}
                                  </span>
                                  <div className="clear-float"></div>
                                </div>
                              ))}
                          </div>
                        </div>
                      ) : (
                        <span
                          className="extra-small-blue t-bold margin-bottom-16 display-block clear-left cursor-pointer"
                          onClick={this.getRatingDetails}
                        >
                          Show rating scale
                        </span>
                      )}
                    </div>
                    <div className="clear-float"></div>
                    <span className="extra-small-dark-disabled t-bold display-block clear-left margin-top-16">
                      Only number rating available in 7 and 10 point scale.
                    </span>
                  </div>
                ) : (
                  <div className="light-grey-bg width60">
                    <span style={{ width: 220, display: "block" }}>
                      <DynamicForm
                        fields={selectinputconverter({
                          value: selectedQuestion.weightagetypeid,
                          placeholder: "0x",
                          label: "Set weightage",
                          disabled: true,
                          options: WeightageType,
                        })}
                        onChange={(value) => {
                          this.handlequestionChange(value, "weightagetypeid");
                        }}
                      />
                    </span>
                    <div
                      style={{
                        width: 220,
                      }}
                    >
                      <DynamicForm
                        fields={selectinputconverter({
                          value: selectedQuestion.questioninputtypeid,
                          placeholder: "Select input type",
                          label: "Input type",
                          options: inputtypes,
                        })}
                        onChange={(value) => {
                          this.handlequestionChange(
                            value,
                            "questioninputtypeid",
                          );
                        }}
                      />
                    </div>
                    {selectedQuestion.questioninputtypeid == 2 ? (
                      <div>
                        <p className="input-label margin-bottom-8">
                          Create multiple choice options
                        </p>
                        <div>
                          {selectedQuestion &&
                            selectedQuestion &&
                            selectedQuestion.questioninputoption &&
                            selectedQuestion.questioninputoption.map(
                              (option, optionindex) => (
                                <div>
                                  <span
                                    style={{
                                      width: 220,
                                      marginRight: 16,
                                      float: "left",
                                    }}
                                  >
                                    <DynamicForm
                                      fields={textinputconverter({
                                        value: option.optionname,
                                        placeholder: "Enter option",
                                        label: "",
                                      })}
                                      onChange={(value) => {
                                        this.handlequestionChange(
                                          value,
                                          "optionname",
                                          optionindex,
                                        );
                                      }}
                                    />
                                  </span>
                                  <span
                                    className="cursor-pointer"
                                    style={{ float: "left", marginTop: 12 }}
                                    onClick={() =>
                                      this.cancelOption(optionindex)
                                    }
                                  >
                                    <img src={crossIcon}></img>
                                  </span>
                                  <div className="clear-float"></div>
                                </div>
                              ),
                            )}
                          <p
                            className="normal-blue cursor-pointer t-bold"
                            onClick={this.addNewOption}
                          >
                            + Add option
                          </p>
                          {/* <CallOutNew
                            classnames="bg-light-blue width100"
                            header="Are you sure employees won't select the first option and move on?"
                            emoji=""
                            textcolor="#1e8ced"
                          /> */}
                {/* {this.state.addoptions && (
                            <DynamicForm
                              fields={textinputconverter({
                                value: this.state.option1,
                                placeholder: "Enter option",
                                label: "",
                              })}
                              onChange={(value) => {
                                this.handleChange(value, "option1");
                              }}
                            />
                          )} */}
                {/* </div>
                      </div>
                    ) : (
                      selectedQuestion.questioninputtypeid == 1 && (
                        <div>
                          <div style={{ width: 220 }}>
                            <DynamicForm
                              fields={selectinputconverter({
                                value: selectedQuestion.sizetypeid,
                                placeholder: "Select text type",
                                label: "",
                                options: texttypes,
                              })}
                              onChange={(value) => {
                                this.handlequestionChange(value, "sizetypeid");
                              }}
                            />
                          </div>
                        </div>
                      )
                    )}
                  </div> */}

                {/* <p className="small-dark-secondary margin-bottom-16 padding-top-10">
                  Question is applicable to
                </p>
                <div className="width60">
                  {ParticipantType
                    && ParticipantType.map((option) => (
                      <div>
                        <div
                          style={{
                            width: 220,
                            marginRight: 16,
                            float: "left",
                          }}
                        >
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value: selectedQuestion.questionevaluation.find(
                                (obj) =>
                                  obj.participanttypeid == option.displayvalue,
                              )
                                ? true
                                : false,
                              placeholder: "Enter option",
                              label: option.displayname,
                            })}
                            onChange={(value) => {
                              const object = selectedQuestion.questionevaluation.find(
                                (obj) =>
                                  obj.participanttypeid == option.displayvalue,
                              );
                              if (object && object.questionevaluationid) {
                                this.props.closeSnackbar();
                                this.props.enqueueSnackbar(
                                  "Are you sure you want to remove this participant from this question?",
                                  {
                                    variant: "warning",
                                    action: [
                                      <Button
                                        key="key"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                          this.handlequestionChange(
                                            value,
                                            "participanttypeid",
                                            option.displayvalue,
                                          );
                                          this.props.closeSnackbar();
                                        }}
                                      >
                                        Yes
                                      </Button>,
                                      <Button
                                        key="key"
                                        color="inherit"
                                        size="small"
                                        onClick={() =>
                                          this.props.closeSnackbar()
                                        }
                                      >
                                        No
                                      </Button>,
                                    ],
                                  },
                                );
                              } else {
                                this.handlequestionChange(
                                  value,
                                  "participanttypeid",
                                  option.displayvalue,
                                );
                              }
                            }}
                          />
                        </div>
                        <div className="clear-float"></div>
                      </div>
                    ))}

                </div> */}

                <div className="floatleft margin-top-24">
                  <Button
                    className="btn btn-secondary-md-blue"
                    onClick={this.onReset}
                    variant="contained"
                  >
                    Reset
                  </Button>

                  <Button
                    className="btn btn-secondary-md-red margin-left-8"
                    variant="contained"
                    onClick={this.deleteQuestion}
                  >
                    Delete
                  </Button>
                </div>
                <div className="floatright margin-top-24">
                  <Button
                    className="btn btn-secondary-md-blue margin-right-16"
                    onClick={this.addfocusarea}
                    variant="contained"
                  >
                    Add focus area
                  </Button>

                  <Button
                    className="btn btn-primary-md-blue"
                    variant="contained"
                    onClick={this.addQuestion}
                  >
                    Add new question
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    );
  }
}

SectionB.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(SectionB)));
